<div class="modal fade" id="kt_modal_testimonial_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Testimonial' : 'Add Testimonial' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="testimonialForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- User Search -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">User</label>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control form-control-solid"
                  placeholder="Search User..."
                  [(ngModel)]="userSearchTerm"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onUserSearchInput($event)"
                  (focus)="onUserInputFocus()"
                  (blur)="onUserInputBlur()"
                  autocomplete="off"
                />

                <!-- Dropdown -->
                <div class="dropdown-menu w-100 show" *ngIf="showUserDropdown" style="max-height: 300px; overflow-y: auto;">
                  <!-- Loading -->
                  <div class="dropdown-item text-center py-3" *ngIf="isUserSearching">
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    Searching...
                  </div>

                  <!-- Results -->
                  <button
                    type="button"
                    class="dropdown-item cursor-pointer"
                    *ngFor="let user of userSearchResults"
                    (click)="selectUser(user)">
                    <div class="d-flex flex-column">
                      <span class="fw-bold">{{ user.name }}</span>
                      <span class="text-muted fs-7">{{ user.country_obj?.name || 'N/A' }}</span>
                    </div>
                  </button>

                  <!-- No Results -->
                  <div class="dropdown-item text-center py-3 text-muted"
                    *ngIf="!isUserSearching && userSearchResults.length === 0">
                    No users found
                  </div>
                </div>

                <!-- Selected User Display -->
                <div class="mt-2" *ngIf="selectedUser">
                  <div class="d-flex align-items-center bg-light-primary rounded p-3">
                    <div class="flex-grow-1">
                      <span class="fw-bold text-primary">{{ selectedUser.name }}</span>
                      <span class="text-muted ms-2">{{ selectedUser.country_obj?.name || 'N/A' }}</span>
                    </div>
                    <button
                      type="button"
                      class="btn btn-sm btn-icon btn-light-danger"
                      (click)="clearUserSelection()"
                      title="Clear Selection">
                      <i class="ki-duotone ki-cross fs-5">
                        <span class="path1"></span>
                        <span class="path2"></span>
                      </i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Message -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Message</label>
              <textarea
                class="form-control form-control-solid"
                formControlName="message"
                rows="4"
                placeholder="Enter testimonial message"
                [class.is-invalid]="message?.invalid && message?.touched">
              </textarea>
              <div *ngIf="message?.invalid && message?.touched" class="invalid-feedback">
                <div *ngIf="message?.errors?.['required']">Message is required</div>
                <div *ngIf="message?.errors?.['minlength']">Message must be at least 10 characters</div>
              </div>
            </div>

            <!-- Rating -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Rating</label>
              <select
                class="form-select form-select-solid"
                formControlName="rating"
                [class.is-invalid]="rating?.invalid && rating?.touched">
                <option value="">Select Rating</option>
                <option *ngFor="let rate of ratingOptions" [value]="rate">
                  {{ rate }} Star{{ rate > 1 ? 's' : '' }}
                </option>
              </select>
              <div *ngIf="rating?.invalid && rating?.touched" class="invalid-feedback">
                <div *ngIf="rating?.errors?.['required']">Rating is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
